var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3L19.1452 4.67853M6 18L7.84999 12.9393M3 3V18C3 19.6569 4.34315 21 6 21H21M12.6977 14.5786L9.28088 12.4655M17.7003 6.67237L14.5219 13.8475M19.4998 5.55042C19.4998 6.24038 18.9404 6.79971 18.2505 6.79971C17.5605 6.79971 17.0012 6.24038 17.0012 5.55042C17.0012 4.86045 17.5605 4.30112 18.2505 4.30112C18.9404 4.30112 19.4998 4.86045 19.4998 5.55042ZM15.1463 14.9296C15.1463 15.6195 14.587 16.1788 13.897 16.1788C13.2071 16.1788 12.6477 15.6195 12.6477 14.9296C12.6477 14.2396 13.2071 13.6803 13.897 13.6803C14.587 13.6803 15.1463 14.2396 15.1463 14.9296ZM9.50162 11.7562C9.50162 12.4462 8.94229 13.0055 8.25233 13.0055C7.56236 13.0055 7.00304 12.4462 7.00304 11.7562C7.00304 11.0663 7.56236 10.5069 8.25233 10.5069C8.94229 10.5069 9.50162 11.0663 9.50162 11.7562Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.c3835fd2e96bf80576119f745ca1da1a.svg";
export { ForwardRef as ReactComponent };